export const BASIC_INFORMATION_FIELDS = [
    {
        label: 'First Name*',
        name: 'contactFirstName',
        type: 'text',
        required: true,
        placeholder: 'First Name',
        errorMessage: 'First Name',
        component: 'input'
    },
    {
        label: 'Last Name*',
        name: 'contactLastName',
        type: 'text',
        required: true,
        placeholder: 'Last Name',
        errorMessage: 'Last Name',
        component: 'input'
    },
    {
        label: 'Company Name*',
        name: 'requestorBusinessName',
        type: 'text',
        required: true,
        placeholder: 'Enter Company Name',
        errorMessage: 'Company Name',
        component: 'input'
    },
    {
        label: 'Job Title*',
        name: 'requestorJobTitle',
        type: 'text',
        required: true,
        placeholder: 'Enter Job Title',
        errorMessage: 'Job Title',
        component: 'input'
    },
    {
        label: 'Country of Origin*',
        name: 'requestorCountryOrOrigin',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Country of Origin'
    },
    {
        label: 'Mobile Number*',
        name: 'requestorMobileNumber',
        required: true,
        type: 'phone',
        placeholder: 'Enter Mobile Number',
        errorMessage: 'Mobile Number'
    },
    {
        label: 'Work Email*',
        name: 'contactWorkEmail',
        required: true,
        type: 'text',
        placeholder: 'Enter Work Email',
        errorMessage: 'Work Email',
        component: 'input'
    },
    {
        label: 'Company Website URL*',
        name: 'requestorCompanyWebsiteURL',
        required: true,
        type: 'text',
        placeholder: 'Enter company website',
        errorMessage: 'Company Website URL',
        component: 'input'
    },
    {
        label: 'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy?*',
        name: 'whereYourCompanyHearAboutBIDProgram',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy',
        component: 'input',
        disabled: true,
    },
    {
        label: 'Please upload your Corporate Presentation*',
        name: 'corporatePresentation',
        required: true,
        type: 'file',
        placeholder: 'Enter Designation',
        errorMessage: 'Corporate Presentation'
    }
];

export const BUSINESS_INFORMATION_FIELDS = [
    {
        label: 'Select your industry vertical*',
        name: 'requestorIndustryVertical',
        type: 'select',
        required: true,
        placeholder: 'Select an option',
        errorMessage: 'Industry vertical',
        component: 'input'
    },
    {
        label: 'Please specify other industry vertical*',
        name: 'otherIndustryVertical',
        required: true,
        type: 'text',
        placeholder: 'Enter other industry vertical',
        errorMessage: 'Other industry vertical',
        component: 'input'
    },
    {
        label: 'Year of Business Incorporation (When was your company established?)*',
        name: 'requestorBusinessIncorporationYear',
        required: true,
        type: 'text',
        placeholder: 'Enter year',
        errorMessage: 'Year of Business Incorporation',
        component: 'input'
    },
    {
        label: 'Is the business owned or co-founded by a UAE national?*',
        name: 'businessOwnedOrCofoundedByUAE',
        type: 'select',
        required: true,
        placeholder: 'Select an option',
        errorMessage: 'Is the business owned or co-founded by a UAE national',
        component: 'input'
    },
    {
        label: 'Number of Employees Globally*',
        name: 'numberOfEmployees',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage: 'Number of Employees'
    },
    {
        label: 'Company annual revenue (in USD)*',
        name: 'requestorAnnualRevenue',
        required: true,
        type: 'select',
        placeholder: 'Select Annual Revenue',
        errorMessage: 'Annual Revenue',
        component: 'input'
    },
    {
        label: 'Please provide information about the current funding stage of your company*',
        name: 'requestorCompanyCurrentFundingStage',
        required: true,
        type: 'select',
        placeholder: 'Select an option',
        errorMessage:
            'Information about the current funding stage of your company',
        component: 'input'
    },
    {
        label: 'Please select the countries outside your country headquarters where you have offices in*',
        name: 'requestorOutsideHeadquarterCountires',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select an option',
        errorMessage:
            'Countries outside your country headquarters where you have offices in',
        component: 'input'
    },
    {
        label: 'Please select the type of support you require, and the corporate services you wish to access*',
        name: 'shortFormSupportAndService',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select an option',
        errorMessage:
            'The type of support you require, and the corporate services you wish to access',
        component: 'input'
    },
    {
        label: 'Please specify other support and service*',
        name: 'otherShortFormSupportAndService',
        required: true,
        type: 'text',
        placeholder: 'Enter other support and service',
        errorMessage: 'Other support and service',
        component: 'input'
    }
];